import { Dispatch, ReactElement } from 'react';
import { Checkbox, styled } from '@mui/material';
import { map as lmap, compose as lcompose } from 'lodash/fp';
import { IDeaNumUser, includes, ValueLabel, variables } from '../common';
import { left, right, fold } from 'fp-ts/lib/Either';
import { showDetails, TeamRequestAction } from '.';

export const renderStack =
  (properties: ValueLabel<keyof IDeaNumUser>[]) =>
  ({
    selectedUserRoleKeys,
    dispatchTeamRequest,
  }: {
    selectedUserRoleKeys: string[];
    dispatchTeamRequest: Dispatch<TeamRequestAction>;
  }) =>
    lcompose(
      fold(
        () => <article>Empty</article>,

        deaNumUsers => (
          <Wrapper>
            {lmap<IDeaNumUser, ReactElement>(a => (
              <ItemWrapper key={`${a.role}-${a.userProfileId}`}>
                {lmap<ValueLabel<keyof IDeaNumUser>, ReactElement>(
                  ({ value, label }) => (
                    <Line key={value}>
                      <Label>{label}:</Label>
                      <span>{showDetails(a)(value)}</span>
                    </Line>
                  )
                )(properties)}

                <SelectLine key="select">
                  <Label>Select:</Label>
                  <Checkbox
                    onClick={() =>
                      dispatchTeamRequest({
                        type: 'ToggleUserRole',
                        payload: a.key,
                      })
                    }
                    color="primary"
                    inputProps={{ 'aria-label': 'select' }}
                    checked={includes(selectedUserRoleKeys)(a.key)}
                  />
                </SelectLine>
              </ItemWrapper>
            ))(deaNumUsers)}
          </Wrapper>
        )
      ),
      (deaRegistrations: IDeaNumUser[]) =>
        deaRegistrations.length === 0
          ? left(deaRegistrations)
          : right(deaRegistrations)
    );

const Wrapper = styled('article')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',

  '&>*+*': {
    marginTop: '0.5rem',
  },
}));

const ItemWrapper = styled('article')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',

  '&>*+*': {
    marginTop: '0.5rem',
  },

  paddingBottom: '0.5rem',
  borderBottom: variables.cardBorder,
}));

const Line = styled('span')(({ theme }) => ({
  '&>*+*': {
    marginLeft: '1rem',
  },
}));

const SelectLine = styled('span')(({ theme }) => ({
  '&>*+*': {
    marginLeft: '1rem',
  },

  display: 'flex',
  alignItems: 'center',
}));

const Label = styled('span')(({ theme }) => ({ fontWeight: 700 }));
